import { cn } from "@omni/utils/styles";

export const VolumeSkeleton = () => {
    return (
        <>
            <div className={cn("tw:h-7.5 tw:w-12 tw:rounded-sm tw:bg-grey")} />
            <div className={cn("tw:h-7.5 tw:w-13 tw:rounded-sm tw:bg-grey")} />
            <div className={cn("tw:h-7.5 tw:w-15 tw:rounded-sm tw:bg-grey")} />
            <div className={cn("tw:h-7.5 tw:w-12 tw:rounded-sm tw:bg-grey")} />
            <div className={cn("tw:h-7.5 tw:w-12 tw:rounded-sm tw:bg-grey")} />
            <div className={cn("tw:h-7.5 tw:w-13 tw:rounded-sm tw:bg-grey")} />
            <div className={cn("tw:h-7.5 tw:w-14 tw:rounded-sm tw:bg-grey")} />
            <div className={cn("tw:h-7.5 tw:w-13 tw:rounded-sm tw:bg-grey")} />
        </>
    );
};
